<template>
  <v-row>
    <v-col cols="12" class="ledger">
      <v-card class="rounded-lg white">
        <v-card-title class="secondary--text">{{ title }}</v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" md="8">
              <account-select
                  label="حساب"
                  items-type="level3"
                  :horizontal="true"
                  v-model="bill.account"
                  :floatAccount1.sync="bill.floatAccount1"
                  :floatAccount2.sync="bill.floatAccount2"
                  :floatAccount3.sync="bill.floatAccount3"
                  :floatAccount4.sync="bill.floatAccount4"
                  @input="setAccount"
              />
            </v-col>
            <v-col cols="12" md="4">
              <v-switch color="success" inset label="احتساب مانده از قبل" v-model="filters.consider_previous_remain"></v-switch>
            </v-col>
            <v-col cols="12" v-if="bill.account">
              <sanad-item-list-report
                  :filter-row="true"
                  :filters.sync="filters"
                  :showAccountInTable="false"
                  :showFinancialYear="true"
                  :showLink="false"
                  :sortable="true"
                  :show-sum="true"
                  :filterable="true"
                  :showRemain="true"
                  :showPreviousRemain="filters.consider_previous_remain"
                  :considerFinancialYear="false"
                  :colspan="4"
              />
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import accountApiMixin from "@/mixin/accountMixin";
import SanadItemListReport from "@/components/mcomponents/report/SanadItemListReport";
export default {
  name: "Bill",
  components: { SanadItemListReport },
  mixins: [accountApiMixin],
  props: {
    ledgerAccountIds: {
      default: () => [],
    },
  },
  data() {
    return {
      bill: {},
      filters: {
        account: null,
        floatAccount1: null,
        floatAccount2: null,
        floatAccount3: null,
        floatAccount4: null,
        title: "صورت حساب تفصیلی",
        account_title: "",
        consider_previous_remain: "true",
        report_type: "bill",
      },
    };
  },
  computed: {
    title() {
      return this.setDocumentTitle('صورت حساب تفصیلی')
    },
  },
  watch: {
    bill: {
      deep: true,
      handler() {
        if (this.bill.account) this.filters.account = this.bill.account.id;
        else this.filters.account = null;

        if (this.bill.floatAccount1) this.filters.floatAccount1 = this.bill.floatAccount1.id;
        else this.filters.floatAccount1 = null;

        if (this.bill.floatAccount2) this.filters.floatAccount2 = this.bill.floatAccount2.id;
        else this.filters.floatAccount2 = null;

        if (this.bill.floatAccount3) this.filters.floatAccount3 = this.bill.floatAccount3.id;
        else this.filters.floatAccount3 = null;

        if (this.bill.floatAccount4) this.filters.floatAccount4 = this.bill.floatAccount4.id;
        else this.filters.floatAccount4 = null;
      },
    },
  },
  methods: {
    setAccount(account) {
      if (account) {
        this.filters.account = account.id;
        this.filters.account_title = account.title;
      }
    },
  },
};
</script>

<style scoped lang="scss"></style>
